import ValuableDTO from "@/dto/taxation/individual/ValuableDTO";

export default class ValuableCloneableDTO<T> extends ValuableDTO<T> {

    public isCloned!: boolean;

}